import { render, staticRenderFns } from "./CalendarScreen.vue?vue&type=template&id=0e15b8bb"
import script from "./CalendarScreen.vue?vue&type=script&lang=js"
export * from "./CalendarScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports